import React, { FC } from 'react';
import { IconButton, InputAdornment } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';

interface IProps extends WithStyles<typeof styles> {
  query: string;
  onClear: () => void;
}

const styles = (theme: Theme) =>
  createStyles({
    deleteIcon: {
      transform: 'rotate(45deg)',
      color: theme.custom.palette.grey3,
    },
    transparent: {
      color: 'transparent',
    },
  });

const StartAdornment: FC<IProps> = ({ classes, query, onClear }) => (
  <InputAdornment position="end">
    <IconButton onClick={onClear}>
      <AddCircleIcon className={query ? classes.deleteIcon : classes.transparent} />
    </IconButton>
  </InputAdornment>
);

export default withStyles(styles)(StartAdornment);
